import { MeetingState } from '../types/meetings';

export const statusesMap = new Map<MeetingState, string>([
  ['closed', '#FF6260'],
  ['open', '#3BDE86'],
  ['locked', '#FFAF2F'],
]);
